export const enumToOptions = (enumObject: any) => {
  return Object.keys(enumObject).map((key) => {
    return { value: enumObject[key], label: key };
  });
};

export const getContentRange = (
  contentRangeHeader: string
): [number, number, number] => {
  const [, start, end, total] = contentRangeHeader.match(
    /(\d*)-(\d*)\/(\d*)/
  ) || [0, 0, 0];
  return [+start, +end, +total];
};
